import { useMarketAccountsContext } from '@talos/kyoko';
import { useMemo } from 'react';
import { filterMarketAccounts, filterMarkets } from '../components/MarketAccountSelectionList/utils';

/** Get a list of marketAccounts and markets without any overlap. Markets with accounts and inactive marketAccounts will be excluded */
export function useCombinedMarketsAndAccounts(marketAccounts: string[], markets: string[]) {
  const { marketAccountsByName, marketAccountsByMarket } = useMarketAccountsContext();
  const selectedCombined = useMemo(() => {
    // filter out markets and marketAccounts that are no longer here/available
    const filteredMarkets = filterMarkets(markets, marketAccountsByMarket);
    const filteredMarketAccounts = filterMarketAccounts(
      marketAccounts,
      markets,
      marketAccountsByMarket,
      marketAccountsByName
    );
    return filteredMarketAccounts.concat(filteredMarkets).toSorted();
  }, [marketAccounts, markets, marketAccountsByName, marketAccountsByMarket]);

  return selectedCombined;
}
